import { GET_CONSTANTS_SUCCESS } from "../constants/serverConstants";

const initialState = {
  constants: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONSTANTS_SUCCESS:
      return {
        ...state,
        constants: action.payload
      };
    default:
      return state;
  }
}
